import { Component, signal, OnInit, computed, inject } from '@angular/core';
import { AuthService } from '../../../core/service/auth/auth.service';

@Component({
  selector: 'app-main-layout',
  standalone: false,
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {
  private authService = inject(AuthService);
  // Follows the working federation (switching it from the sidebar does not recreate the layout)
  federationLogoUrl = computed(() => this.authService.currentFederation()?.logo_url || null);
  // Key of the router outlet: a new federation re-creates the page so it reloads that federation's data
  outletKey = computed(() => [this.authService.currentFederation()?.federation_id ?? 0]);
  lostFederationNotice = this.authService.lostFederationNotice;
  accessLevel = signal<'full' | 'readonly' | 'blocked'>('full');
  isLoading = signal(true);


  ngOnInit(): void {
    this.accessLevel.set(this.authService.getAccessLevel());
    this.isLoading.set(false);
  }

  dismissNotice(): void {
    this.authService.clearLostFederationNotice();
  }

  logout(): void {
    // Logout is handled in header component
  }
}
